import React, { Component } from 'react'
import { t } from '@lingui/macro'
import './NotFound.less'

import IconGhost from '../icon/IconGhost'

export interface INotFoundProps {
  message?: string
}

// TODO refactor to FC
export default class NotFound extends Component<INotFoundProps> {
  static defaultProps = {
    message: t`No items found`
  }

  render() {
    const { message } = this.props

    return (
      <div className="NotFound">
        <IconGhost size="large" />

        <h3>{message}</h3>
      </div>
    )
  }
}
